import { IDefaultService } from "../default-service/default-service.interface";

// Essa interface é usada em um componente de botão que exibe uma lista de botões de experiência remota. Cada botão tem um ícone, título, subtítulo, preço, preço antigo e um aviso. A interface `IExperienceRemoteButton` define as propriedades de cada botão apenas para estilização.
export interface IRemoteExperienceButton {
  id: number;
  active: boolean;
  disabled: boolean;
  isSelected: boolean;
  icon: string;
  iconDisabled: string;
  title: string;
  subtitle: string;
  textModal: string;
  price: string;
  oldPrice: string;
  warning: string;
  modality: string;
}

export interface IRemoteExperienceService extends IDefaultService {
  pickupDelivery: boolean;
  mobileService: boolean;
  winchService: boolean;

  // MOCK TEMPORÁRIO - AFOSR-2276 (OSR_PDL_UPGRADE_AFOSR_2276): marcadores usados para
  // identificar os serviços mockados de "somente retirada" e "somente entrega"
  // (quebra do serviço Leva e Traz), enquanto o back-end não os disponibiliza via API.
  // TODO: remover estas propriedades quando o back-end implementar os serviços de fato.
  pickupOnly?: boolean;
  deliveryOnly?: boolean;
}
